import { useTranslation } from "react-i18next";

import { ArrowRight } from "@/assets/icons/icons.tsx";
import { DeviceTile } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceTile/DeviceTile.tsx";
import { getItemizedBillsRedirectLink } from "@/utils/itemizedBillLink.ts";

export const PromoItemizedBillTile = () => {
  const { t } = useTranslation("portal");

  return (
    <a href={getItemizedBillsRedirectLink()} target="_blank" rel="noreferrer">
      <DeviceTile dataTestid="promo-itemized-bill-tile">
        <div className="m-auto">
          <p className="text-left text-base leading-normal text-secondary-100">
            {t("layout.tiles.promoItemizedBill.heading")}
          </p>
          <h2 className="mt-6 text-primary-100">
            {t("layout.tiles.promoItemizedBill.text")}
          </h2>
        </div>
        <div className="button-wrapper">
          <button className="button">
            <span className="manage">
              {t("layout.tiles.promoItemizedBill.activateNow")}
            </span>
            <ArrowRight />
          </button>
        </div>
      </DeviceTile>
    </a>
  );
};
